var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"changed-box-container"},[_c('div',{staticClass:"changed-box-container__prepend"},[_c('ChangedBox',{attrs:{"active":_vm.active}})],1),_vm._t("middle"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }